import { css } from '@emotion/core';
import { StyledColumnWrapper } from './styles';
export default (function (theme) {
  return /*#__PURE__*/css("--column-margin--side:0;--column-margin--row:0;", StyledColumnWrapper, "{padding:0;}");
});